export default __webpack_public_path__ + "static/media/warning--weight-limit-per-tandem-axle--g1.bce254f9.png";